import React, { useEffect, useState } from "react";
import { Button, Box } from "@mui/material";
import FormField from "../FormComponent/FormField/FormField";
import styles from './practitioner.module.css';
import { useForm, useWatch } from 'react-hook-form';
import { axiosProxyInstance } from "../../utils/request";
import cogoToast from "cogo-toast";

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import isEqual from "lodash/isEqual";

const validationSchema = yup.object({
    insuranceAccepted: yup.array(),
});

const Insurance = ({ sectionData, details }) => {
  
  const [defaultValues, setDefaultValues] = useState(null);
  const form = useForm({
    mode: "onBlur",
    resolver: yupResolver(validationSchema),
    defaultValues: {
      insuranceAccepted: [] 
    }
  });

  const { register, handleSubmit, control, formState: { errors }, reset, watch, setValue } = form;

  const allFields = sectionData.fields;
  const insuranceAcceptedField = allFields.find(field => field.id === "insuranceAccepted");
  const currentUserId = localStorage.getItem("LPCurrentUserId");

  useEffect(() => {
    if (details?.data?.health_insurances_accepted) {
      const selectedInsurances = Object.values(details.data.health_insurances_accepted); // ["Bupa", "AXA"]
      const resData =  {
        insuranceAccepted: selectedInsurances
      };
      reset(resData);
      setDefaultValues(resData);
    }
  }, [details, reset]);

  const onSubmit = async (data) => {
    const payload = {
      btn_submit: true,
      listings: [
        {
          listing_id: details?.ID,
          title: details?.post_title,
          address_1: details?.data.address_1,
          postcode: details?.data.postcode,
          telephone_1: details?.data?.phone?.raw,
          specialization: (Object.values(details.data.services || {})),
          treatments: Object.values(details.data.treatments || {}),
          health_insurances_accepted: data.insuranceAccepted,
          provideruid: currentUserId,
          uid: currentUserId
        }
      ]
    };
    try {
      const res = await axiosProxyInstance.post('/signup/2/', payload);
      cogoToast.success("Insurance Updated Successfully!");
    } catch (err) {
      console.error("Submission failed:", err);
    }
  };

  const watchedInsurance = useWatch({ control, name: "insuranceAccepted" });

  const isFormDirty = defaultValues
    ? !isEqual(watchedInsurance, defaultValues.insuranceAccepted)
    : false;

  return (
    <Box className="margin-top-15">
      <form onSubmit={handleSubmit(onSubmit)}>

        <Box style={{ flex: "1" }}>
          <FormField
            field={insuranceAcceptedField}
            register={register}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            form={form}
          />
          <Box className={styles.submitButtonContainer}>
            <Button disabled={!isFormDirty} className={styles.primaryButton} size="large" type="submit">
              Save Changes
            </Button>
            <Button 
              disabled={!isFormDirty} className={styles.secondaryButton} size="large"
              onClick={() => reset(defaultValues)}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default Insurance;
